export default [
  'event/getRelatedPublicOpinion',
  'event/getEventTopicByEventNumber',
  'currency/getAuthLink',
  'scout/getRegionHistoryExposureRecord',
  'point/getExistPoint',
  'region/getPackageRegionByFunctionId',
  'region/getPackageFreeRegionByFunctionId',
  'point/pointRegionTask',
  'point/pointRegionWorkRecord',
  'point/getGPSJamData',
  'point/getNOTAMData',
  'point/pointPackagePanelCalendar',
  'scout/relatedPublicOpinion',
  'system/getNewMessage',
  'scout/getRegionSubscribeInfo',
  'RegionApi/getGlobalExposureDataByPermissionRegionToday',
  'UserWorkspaceDataApi/queryRegionFeatureList',
  'UserWorkspaceDataApi/getEventListByCoordinates',
  'UserWorkspaceDataApi/getExposurePolygonByRegionAndDate',
  'UserWorkspaceDataApi/queryAnnotation',
  'RegionApi/getAirBaseByRegion',
  'WorkbenchApi/queryWorkbenchContent',
]